import { Component } from '@angular/core';

@Component({
  selector: 'app-agenda-icon',
  imports: [],
  templateUrl: './agenda-icon.html',
  styleUrl: './agenda-icon.css'
})
export class AgendaIcon {

}
